const backInStockForm = class extends HTMLElement {
  constructor () {
    super()

    this.product = this.closest('[data-product]');

    console.log(true);

    if (!this.product) { return; }

    this.variantInput = this.product.querySelector('input[name="id"]')
    this.bisForm = this.querySelector('[data-bis-form]')
    this.bisVariantInput = this.querySelector('[data-bis-variant]')
    this.bisEmailInput = this.querySelector('[data-bis-email]')
    this.successEl = this.querySelector('[data-bis-success-response]')
    this.errorEl = this.querySelector('[data-bis-error-response]')
    this.app = this.getAttribute('data-app')

    this.bisInit()
  }

  bisInit () {
    this.bisForm.addEventListener('submit', async (event) => {
      event.preventDefault()

      const variantId = Number(this.variantInput.value)

      try {
        if (this.app === 'back_in_stock') {
          await this.handleBisAppSubmit(variantId)
        } else if (this.app === 'klaviyo') {
          await this.handleKlaviyoBisSubmit()
        } else {
          throw new Error('app not defined')
        }

        this.bisForm.classList.add('hidden')
        this.successEl.classList.remove('hidden')
        this.errorEl.classList.add('hidden')
      } catch (error) {
        this.bisForm.classList.add('hidden')
        this.successEl.classList.add('hidden')
        this.errorEl.classList.remove('hidden')
      }
    })

    this.variantInput.addEventListener('change', () => this.bisVariantInput.value = this.variantInput.value)
    document.addEventListener('showBis', () => this.classList.remove('hidden'))
    document.addEventListener('hideBis', () => this.classList.add('hidden'))
  }

  async handleBisAppSubmit (variantId) {
    return new Promise((resolve, reject) => {
      if (typeof window.BISPopover === 'undefined') {
        reject(Error('BISPopover not defined'))
      }

      BISPopover.create(bisEmailInput.value, variantId).then(data => { // eslint-disable-line
        if (data.status !== 'OK') {
          reject(Error(data.errors.base[0]))
        } else {
          resolve(data)
        }
      })
    })
  }

  async handleKlaviyoBisSubmit () {
    const data = new window.FormData(this.bisForm)

    try {
      return fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
        method: 'POST',
        body: data
      }).then((response) => {
        return response
      })
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

if (typeof window.customElements.get('bis-form') === 'undefined') {
  window.customElements.define('bis-form', backInStockForm)
}